import { render, staticRenderFns } from "./GraphDetail12.vue?vue&type=template&id=4be2cb8f&scoped=true"
import script from "./GraphDetail12.vue?vue&type=script&lang=js"
export * from "./GraphDetail12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be2cb8f",
  null
  
)

export default component.exports